import { useMutation, useQueryClient } from "@tanstack/react-query";
import { duplicateProgramFunction } from "../../services/programFunction";
import { IIndicators } from "../../types";
import { toast } from "react-toastify";

const useDuplicateProgramFunction = (indicators: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: duplicateProgramFunction,

        onMutate: () => {
            indicators.setIsProcessRunning(true);
        },

        onSuccess: (status) => {
            if (status === 200) {
                indicators.setIsProcessRunning(false);
                queryClient.invalidateQueries({ queryKey: ['categories'] });
                toast.success("Program function duplicated successfully");
            }
        },

        onError: (error: any) => {
            indicators.setIsProcessRunning(false);
            indicators.setIsServiceError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        }
    });
}

export default useDuplicateProgramFunction;